var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgD3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2500,
  height: 2373,
  viewBox: "0 0 256 243",
  preserveAspectRatio: "xMinYMin meet"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-82.637%",
  y1: "-92.82%",
  x2: "103.767%",
  y2: "106.042%",
  id: "d3_svg__a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A03C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7974E",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-258.924%",
  y1: "-248.97%",
  x2: "97.62%",
  y2: "98.768%",
  id: "d3_svg__b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A03C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7974E",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "-223.163%",
  y1: "-261.968%",
  x2: "94.028%",
  y2: "101.691%",
  id: "d3_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A03C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7974E",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "11.339%",
  y1: "-1.822%",
  x2: "82.496%",
  y2: "92.107%",
  id: "d3_svg__d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F26D58",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A03C",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "15.844%",
  y1: "3.858%",
  x2: "120.126%",
  y2: "72.38%",
  id: "d3_svg__e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B84E51",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F68E48",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "46.984%",
  y1: "23.466%",
  x2: "51.881%",
  y2: "147.391%",
  id: "d3_svg__f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A03C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7974E",
  offset: "100%"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M255.52 175.619c.115-1.115.197-2.24.261-3.371.078-1.339-80.562-77.85-80.562-77.85h-1.928s81.736 86.215 82.229 81.22z",
  fill: "url(#d3_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M83.472 149.077c-.107.235-.213.47-.323.704-.114.246-.232.491-.349.734-2.57 5.36 35.987 43.053 39.088 38.474.141-.202.283-.416.424-.618.157-.24.312-.47.467-.71 2.48-3.765-38.206-41.032-39.307-38.584z",
  fill: "url(#d3_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M137.957 202.083c-.109.24-.885 1.552-1.594 2.245-.12.24 37.64 37.688 37.64 37.688h3.4c.002 0-35.446-38.35-39.446-39.933z",
  fill: "url(#d3_svg__c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M255.835 171.568c-1.766 39.147-34.152 70.448-73.72 70.448h-5.35l-39.514-38.928c3.25-4.584 6.272-9.333 8.962-14.285h35.902c11.354 0 20.594-9.235 20.594-20.595 0-11.355-9.24-20.595-20.594-20.595h-21.246c1.619-8.557 2.504-17.381 2.504-26.408 0-9.165-.901-18.114-2.578-26.808h13.197l81.61 80.414c.097-1.078.174-2.155.233-3.243zM21.467 0H0v53.213h21.467c37.493 0 68 30.499 68 67.992 0 10.2-2.275 19.883-6.318 28.576l39.163 38.59c12.859-19.24 20.376-42.339 20.376-67.166C142.688 54.373 88.307 0 21.467 0z",
  fill: "url(#d3_svg__d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M182.115 0H95.187C116.419 12.963 134 31.344 145.979 53.213h36.136c11.354 0 20.594 9.235 20.594 20.595 0 11.357-9.24 20.592-20.594 20.592h-8.12l81.61 80.413c.192-2.181.312-4.376.312-6.605 0-17.939-6.437-34.395-17.125-47.203 10.688-12.802 17.125-29.261 17.125-47.197C255.917 33.112 222.813 0 182.115 0z",
  fill: "url(#d3_svg__e)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M176.765 242.016H95.808c16.296-10.064 30.384-23.35 41.443-38.928l39.514 38.928zm-54.453-53.645-39.16-38.59c-10.819 23.251-34.395 39.422-61.685 39.422H0v53.208h21.467c42.01 0 79.09-21.488 100.845-54.04z",
  fill: "url(#d3_svg__f)"
})));
export { SvgD3 as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/d3.svg";